import React, { useEffect, useState } from "react";
import { Modal } from "MODULES/shared/components";
import { Close, Header } from "MODULES/shared/components/Modal";
import Form from "MODULES/parts/components/Detail/RepairQuotes/Update/Form";
import PropTypes from "prop-types";
import { useDispatch } from "APP_ROOT/hooks";
import api from "APP_ROOT/api";
import { toastr } from "react-redux-toastr";
import { repairQuotesPagination } from "MODULES/parts/pagination";

export default function Update({
  open,
  close,
  lineItem,
  sendRfq,
  setLineItem
}) {
  if (!lineItem) return null;
  const [repairQuote, setRepairQuote] = useState(null);
  useEffect(
    () => {
      api.repairQuotes.show(lineItem.repair_quote_id).then(({ data }) => {
        setRepairQuote(data);
      });
    },
    [lineItem.repair_quote_id]
  );

  if (!repairQuote) return null;
  const { onSubmit } = useOnSubmit(repairQuote, close, sendRfq);
  const {
    company: _company,
    contact: _contact,
    ...initialValues
  } = repairQuote;

  const closeAndClear = () => {
    setLineItem(null);
    close();
  };

  return (
    <Modal open={open} close={closeAndClear}>
      <Header>
        <Close close={closeAndClear} />
        <h4 className="modal-title">Update Quote</h4>
      </Header>
      <Form
        close={closeAndClear}
        repairQuote={repairQuote}
        initialValues={initialValues}
        onSubmit={onSubmit}
        modal
      />
    </Modal>
  );
}

Update.propTypes = {
  close: PropTypes.func.isRequired,
  open: PropTypes.bool,
  lineItem: PropTypes.shape({ id: PropTypes.number }),
  sendRfq: PropTypes.func.isRequired,
  setLineItem: PropTypes.func.isRequired
};

function useOnSubmit(repairQuote, close, sendRfq) {
  const dispatch = useDispatch();

  const onSubmit = async data => {
    const { data: quote } = await api.repairQuotes.update(repairQuote.id, data);

    toastr.success("Success", `${quote.code} successfully updated.`);
    dispatch(repairQuotesPagination.pageActions.expire());

    window.scrollTo(0, 0);

    if (data.sendRfq) {
      sendRfq(quote.repair_quote_line_item);
    }

    close();
  };

  return { onSubmit };
}



// WEBPACK FOOTER //
// ./app/modules/parts/components/RepairQuoteLineItems/Update/Update.jsx